import React from 'react';
import { ProgramType } from 'fitbeat.models';
import { GoalIcon } from '../../ui/components/Icons';
import Theme from '../../theme';

export const mappedIcons = {
  [ProgramType.GetLeanAndFitGoal]: (styles, color = Theme.BLACK) =>
    <GoalIcon goal={ProgramType.GetLeanAndFitGoal} color={color} width={'100%'} height={'100%'} styles={styles} />,
  [ProgramType.GainMuscleAndStrengthGoal]: (styles, color = Theme.BLACK) =>
    <GoalIcon
      goal={ProgramType.GainMuscleAndStrengthGoal}
      color={color}
      width={'100%'}
      height={'100%'}
      styles={styles} />,
  [ProgramType.GetStrongAndFitGoal]: (styles, color = Theme.BLACK) =>
    <GoalIcon goal={ProgramType.GetStrongAndFitGoal} color={color} width={'100%'} height={'100%'} styles={styles} />,
  [ProgramType.MobilityAndTone]: (styles, color = Theme.BLACK) =>
    <GoalIcon goal={ProgramType.MobilityAndTone} color={color} width={'100%'} height={'100%'} styles={styles} />,
  [ProgramType.MuscleAndShred]: (styles, color = Theme.BLACK) =>
    <GoalIcon goal={ProgramType.MuscleAndShred} color={color} width={'100%'} height={'100%'} styles={styles} />,

  [ProgramType.NotSet]: () => null,
};
